import React, { useEffect, useState } from 'react';
import { Modal, Title, CardTextButtons } from '@gerdau/hefesto';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import NavegationMenuBar from '../../../components/NavegationMenuBar';
import { ERoutes } from '../../../routes';
import { ApplicationState } from '../../../store';
import { cleanFabricationPurchaseOrderSettings } from '../../../store/ducks/fabrication-purchase-order/actions';
import { cleanShoppingCart } from '../../../store/ducks/long-steel-shopping-cart/actions';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { EPurchaseRoutes } from '../purchase.routes';
import { Container } from './styles';

const SteelTypeChoose: React.FC = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const shoppingCartItems = useSelector(
    (appState: ApplicationState) => appState.longSteelShoppingCart.items
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );
  const hasLongSteelPurchaseOrderInProgress: boolean =
    shoppingCartItems.length > 0;
  const [
    canShowLongSteelOrderInProgressModal,
    setCanShowLongSteelOrderInProgressModal
  ] = useState(false);

  const fabricationPurchaseOrder = useSelector(
    (appState: ApplicationState) => appState.fabricationPurchaseOrder
  );
  const hasFabricationOrderInProgress: boolean =
    fabricationPurchaseOrder.constructionIdentification.contractNumber !==
      undefined ||
    fabricationPurchaseOrder.constructionIdentification.orderNumber !== '' ||
    fabricationPurchaseOrder.constructionIdentification.desiredDate !==
      undefined;
  const [
    canShowFabricationOrderInProgressModal,
    setCanShowFabricationOrderInProgressModal
  ] = useState(false);

  const { screenName } = getTaggingInformationScreen(
    window.location.pathname,
    true
  );

  const itemsNavBar = [{ name: 'Comprar', url: pathname }];

  const goToLongSteel = () => {
    prepareAndSendTagging(
      'button:comprar_acos_longos',
      'comprar_comprarAcosLongos'
    );
    history.push(`${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}`);
  };

  const goToFabrication = () => {
    prepareAndSendTagging(
      'button:solicitar_corteDobra',
      'comprar_solicitarCorteEDobra'
    );
    history.push(`${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}`);
  };

  const prepareAndSendTagging = (itemName: string, itemDescription: string) => {
    dispatch(
      sendTagging({
        screenName: screenName,
        event: 'click',
        itemName: itemName,
        itemDescription: itemDescription,
        page: window.location.pathname
      })
    );
  };

  useEffect(() => {
    if (!customersState.loading) {
      dispatch(
        sendTagging({
          screenName: screenName,
          event: 'page_view',
          page: window.location.pathname
        })
      );
    }
  }, [dispatch, screenName]);

  const onClickBuyLongSteel = () => {
    if (hasLongSteelPurchaseOrderInProgress) {
      setCanShowLongSteelOrderInProgressModal(true);
    } else {
      goToLongSteel();
    }
  };

  const onClickBuyFabrication = () => {
    if (hasFabricationOrderInProgress) {
      setCanShowFabricationOrderInProgressModal(true);
    } else {
      goToFabrication();
    }
  };

  const onNewOrderClick = () => {
    if (hasFabricationOrderInProgress) {
      dispatch(cleanFabricationPurchaseOrderSettings());
      goToFabrication();
    } else if (hasLongSteelPurchaseOrderInProgress) {
      dispatch(cleanShoppingCart());
      goToLongSteel();
    }
  };

  const onContinueOrderClick = () => {
    if (canShowFabricationOrderInProgressModal) {
      goToFabrication();
    } else if (canShowLongSteelOrderInProgressModal) {
      goToLongSteel();
    }
  };

  return (
    <Container>
      <header>
        <NavegationMenuBar items={itemsNavBar}></NavegationMenuBar>
        <Title level={1}>Compra de aços</Title>
        <span>Qual tipo de aço você gostaria de comprar?</span>
      </header>
      <div className="cards">
        <div className="cards-container">
          <div className="card">
            <CardTextButtons
              title={'Aços longos'}
              description={
                'Arames, barras e perfis, barras trefiladas, malhas, pregos, tarugos, telas, treliças, vergalhões, entre outros.'
              }
              buttonProps={{
                label: 'Comprar aços longos',
                onClick: () => {
                  onClickBuyLongSteel();
                }
              }}
            />
          </div>
          <div className="card">
            <CardTextButtons
              title={'Corte e dobra'}
              description={
                'Aços longos cortados e dobrados conforme meus projetos.'
              }
              buttonProps={{
                label: 'Solicitar corte e dobra',
                onClick: onClickBuyFabrication
              }}
            />
          </div>
        </div>
      </div>

      {(canShowFabricationOrderInProgressModal ||
        canShowLongSteelOrderInProgressModal) && (
        <Modal
          title="Deseja continuar seu último pedido?"
          onClose={() => {
            setCanShowLongSteelOrderInProgressModal(false);
            setCanShowFabricationOrderInProgressModal(false);
          }}
          buttons={{
            left: {
              children: 'Novo pedido',
              name: 'novo-pedido',
              onClick: onNewOrderClick,
              type: 'button'
            },
            right: {
              children: 'Continuar pedido',
              name: 'continuar-pedido',
              onClick: onContinueOrderClick,
              type: 'button'
            }
          }}
          modalSize="sm"
        >
          <span>
            Você possui um pedido em andamento. Para retomar sua compra de onde
            parou clique em continuar pedido.
          </span>
        </Modal>
      )}
    </Container>
  );
};

export default SteelTypeChoose;
